import languageMenu from "@/utils/i18n/locales";
import { useTranslation } from "react-i18next";
import RegistrationHeader from "@/components/auth/registration/Header.tsx";
import useFormStep from "@/utils/hooks/useFormStep.ts";
import OutlinedSelect from "@edusogno/inputs/outlined-select";
import AuthPageFooter from "@edusogno/layouts/auth-page-footer.js";
import { cn } from "@edusogno/lib/utils";
import LoadingButton from "@edusogno/primitives/loading-button";
import RegistrationContainer from "../Container";
import RegistrationContent from "../Content";

interface LanguageProps {
  className?: string;
  onNext: () => void;
}

const RegistrationLanguage = ({ className, onNext }: LanguageProps) => {
  const { t } = useTranslation();
  const { invalid, defaultValue, handleChange } = useFormStep("lang");
  return (
    <>
      <RegistrationContainer className={cn(className)}>
        <RegistrationHeader
          title={t("auth.registration.language_title")}
          subtitle={t("auth.registration.language_subtitle")}
          logo={"language"}
        />
        <RegistrationContent>
          <OutlinedSelect
            className={"w-full"}
            // size={"lg"}
            color={"grey"}
            label={t("auth.labels.language")}
            defaultValue={defaultValue}
            options={languageMenu.map((r) => ({
              label: r.name,
              value: r.value,
            }))}
            onValueChange={handleChange}
            error={invalid}
          />
        </RegistrationContent>
      </RegistrationContainer>
      <AuthPageFooter>
        <LoadingButton
          size={"lg"}
          type="button"
          className="hidden w-full text-lg tracking-wide md:block"
          disabled={invalid}
          onClick={() => onNext()}
        >
          {t("btns.next")}
        </LoadingButton>
        <LoadingButton
          size={"md"}
          type="button"
          className="block w-full text-lg tracking-wide md:hidden"
          disabled={invalid}
          onClick={() => onNext()}
        >
          {t("btns.next")}
        </LoadingButton>
      </AuthPageFooter>
    </>
  );
};

export default RegistrationLanguage;
